import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { MenuItems } from "./MenuItems";
import { trackEvent } from "../../utils/analytics";

/**
 * DROPDOWN (DESKTOP)
 * ==================
 * Desktopin tuoteryhmävalikko.
 *
 * Facelift-linja:
 * - Light mode: valkoinen kortti, tumma teksti, kevyt turkoosi hover.
 * - Dark mode: lähes musta kortti, valkoinen teksti, hillitty border.
 * - Ei raskaita glow-efektejä.
 * - Ei borderin lisäystä hoverissa, jotta layout ei hypi.
 */
const Dropdown = ({ onLinkClick = () => undefined }) => {
  return (
    <div
      className="
        w-[min(96vw,960px)] overflow-hidden rounded-3xl
        border border-[#DDE7E5] bg-white text-[#111827]
        shadow-[0_24px_70px_rgba(15,23,42,0.22)]
        animate-[fadeSlideIn_0.18s_ease-out]
        dark:border-darkborder dark:bg-[#0B0B0D] dark:text-white
      "
    >
      {/* Yläkorostus */}
      <div
        aria-hidden="true"
        className="
          h-1 w-full
          bg-gradient-to-r from-primary via-accent to-secondary
        "
      />

      {/* GRID: yksi sarake per tuoteryhmä */}
      <div className="grid grid-cols-3 gap-6 p-6">
        {MenuItems.map((group) => {
          const subItems =
            group.subMenu1 || group.subMenu2 || group.subMenu3 || [];

          return (
            <div key={group.id} className="min-w-0">
              {/* Ryhmän otsikko */}
              <Link
                to={group.path}
                onClick={() => {
                  trackEvent("valikko_ryhma_klikattu", {
                    ryhma: group.title,
                  });
                  onLinkClick();
                }}
                  className="
                    mb-3 inline-flex max-w-full items-center rounded-full
                    border border-[#DDE7E5] bg-[#F8FAFC] px-4 py-2
                    font-customFont1 text-[11px] font-extrabold uppercase
                    tracking-[0.10em] !text-[#111827] transition
                    hover:border-primary hover:bg-primary hover:!text-[#111827]
                    dark:border-darkborder dark:bg-darksurface dark:!text-white
                    dark:hover:border-primary dark:hover:bg-primary dark:hover:!text-[#111827]
                  "
              >
                <span className="truncate">{group.title}</span>
              </Link>

              {/* Tuotteet */}
              <ul className="space-y-1.5">
                {subItems.map((item, index) => (
                  <li
                    key={item.id}
                    className="transition-transform duration-200 hover:translate-x-1"
                    style={{ transitionDelay: `${index * 15}ms` }}
                  >
                    <Link
                      to={item.slug ? `/tuote/${item.slug}` : item.path}
                      onClick={() => {
                        trackEvent("valikko_tuote_klikattu", {
                          tuote: item.title,
                        });
                        onLinkClick();
                      }}
                        className="
                          group flex min-h-10 items-start justify-between gap-3
                          rounded-xl border border-transparent px-3 py-2
                          font-customFont1 text-[13px] font-semibold !text-[#374151]
                          transition
                          hover:border-primary/30 hover:bg-[#EEF7F6] hover:!text-[#111827]
                          dark:!text-[#D1D5DB]
                          dark:hover:border-primary/30 dark:hover:bg-darksurface2 dark:hover:!text-white
                        "
                    >
                      <span className="min-w-0 whitespace-normal break-words leading-snug">
                        {item.title}
                      </span>

                      {item.isNew && (
                        <span
                          className="
                            shrink-0 rounded-full bg-accent px-2.5 py-1
                            text-[10px] font-extrabold uppercase tracking-wide
                            text-darkest
                          "
                        >
                          Uusi
                        </span>
                      )}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
};

Dropdown.propTypes = {
  onLinkClick: PropTypes.func,
};

export default Dropdown;